import { createPartnerAdminApiStore } from '@/api'

const apiPartnerAdminStore = createPartnerAdminApiStore([
  {
    action: '_AdminLogout',
    path: 'v2/logout',
    method: 'get',
    cacheable: false
  },
  {
    action: '_getAdminInfo',
    path: 'v2/user/my',
    method: 'get',
    cacheable: false
  }
])

export default {
  namespaced: true,
  mixins: [apiPartnerAdminStore],
  state: {
    userInfo: null,
  },
  actions: {
    logout({ state, dispatch, commit }, params) {
      return new Promise((resolve, reject) => {
        dispatch('_AdminLogout').then(
          res => {
            commit('CLEAR_USER')
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
      })
    },
    getAdminInfo({state, dispatch, commit}, params) {
      return dispatch('_getAdminInfo')
    }
  },
  mutations: {
    SET_USER(state, data) {
      sessionStorage.setItem('userInfo', JSON.stringify(data))
      state.userInfo = data
    },
    CLEAR_USER(state) {
      sessionStorage.removeItem('userInfo')
      state.userInfo = null
    },
  },
  getters: {
    userInfo: state => state.userInfo || {},
    getUserInitPage: (state, getters) => {
      const now = new Date()
      const open = new Date('2024-12-01 00:00:00')
      return now >= open ? '/settlement/view' : '/penalty/view'
    },
    
    partnerNo: (state) => {
      if (!state.userInfo?.partner) return null
      return state.userInfo.partner.partnerNo
    },

    partnerInfo: (state) => {
      return state.userInfo?.partner ?? null
    }
  }
}

